import React, { useEffect, useState } from "react";
import { useWindowSize } from "../../util/functionGlobal";
import HeaderPc from "./header-pc";
import BannerHeader from "../bannerHeader/bannerHeader";
import { IBaseBox } from "../../model/base";
import TabBarMobile from "./tabBarMobile";
import classNames from "classnames";
import styles from "./header.module.scss";
interface HeaderProps {
  showBanner: boolean;
  bannerCovid?: boolean;
}

const Header = (props: HeaderProps) => {
  const { showBanner, bannerCovid } = props;
  const { width } = useWindowSize();
  const [dataToday, setDataToday] = useState<IBaseBox[]>([]);
  
  useEffect(() => {
    if (!dataToday || dataToday.length > 0) {
    } else {
      fetch(`/blog/api/get_random`)
        .then((response) => response?.json())
        .then((data) => {
          setDataToday(data.data);
        });
    }
  }, []);

  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <>
      <HeaderPc width={width} />
      {showBanner ? (
        <BannerHeader
        title={typeof window !== "undefined" && mounted && width < 767 ? "Blog" : "Sapo Blog"}
        description="Chia sẻ kinh nghiệm quản lý và bán hàng hợp kênh thiết thực nhất"
        bannerCovid={bannerCovid}
      />
      ) : ("")}
      <div style={{ minHeight: "44px" }} className={classNames(styles["menu_blog_mobile_fixed"], "d-lg-none")}> 
        {mounted && width < 992 && <TabBarMobile dataToday={dataToday} />} 
        </div>
    </>
  );
};

export default Header;
